import { memo, useCallback } from 'react';
import { SidebarSection, SectionTitle, SectionContent, FormGroup } from './FlightPlannerStyles';

/**
 * Shared AI Model selection section used by both Orthomosaic and DSP config panels.
 * Allows selecting an AI model to run automatically after processing.
 */
const AiModelSection = ({
	aiModelUuid,
	onAiModelChange,
	availableAiModels,
	helpText = {
		selected: 'Model runs automatically on the flight polygon after data sync',
		none: 'No automatic detection after processing',
	},
}) => (
	<SidebarSection>
		<SectionTitle>AI Processing</SectionTitle>
		<SectionContent>
			<FormGroup>
				<label>AI Model:</label>
				<select value={aiModelUuid} onChange={e => onAiModelChange(e.target.value)}>
					<option value="">None - manual detection</option>
					{availableAiModels.map(model => (
						<option key={model.uuid} value={model.uuid}>
							{model.name}
						</option>
					))}
				</select>
				<small style={{ color: '#888', fontSize: '0.8rem' }}>
					{aiModelUuid ? helpText.selected : helpText.none}
				</small>
			</FormGroup>
		</SectionContent>
	</SidebarSection>
);

export default memo(AiModelSection);
